import { userService, merchantService, currenciesService } from "@/services";

export default {
  data() {
    return {
      service: userService.getUserNames,
      allUsers: userService.getAllUsers,
      merchantService: merchantService.getMerchantNames,
      merchantType: merchantService.getMerchantTypes,
      allMerchants: merchantService.getAllMerchant,
      getCryptoCurrencyInfo: currenciesService.getAllCryptoCurrency,
      usernamesList: {
        page: 1,
        size: 10,
        name: null,
        timeout: false,
        displayMoreItem: false,
        moreItemsLoading: false,
        autocompleteListLoading: false,
        allItems: []
      },
      businessNamesList: {
        page: 1,
        size: 10,
        name: null,
        extraKey: null,
        timeout: false,
        displayMoreItem: false,
        moreItemsLoading: false,
        autocompleteListLoading: false,
        allItems: []
      },
      businessTypesList: {
        page: 1,
        size: 10,
        name: null,
        timeout: false,
        displayMoreItem: false,
        moreItemsLoading: false,
        autocompleteListLoading: false,
        allItems: []
      }
    };
  },
  methods: {
    inputSearchCheck(val, service, list, key, extraKey) {
      if (this[list].allItems.length === 0) {
        this.inputSearch(val, service, list, key, extraKey);
      }
    },
    inputSearch(val, service, list, key, extraKey) {
      if (!/40|39|38|37/.test(val.keyCode)) {
        this[list].autocompleteListLoading = true;
        clearTimeout(this[list].timeout);
        this[list].timeout = setTimeout(() => {
          if (val.srcElement._value) {
            this[list].name = val.srcElement._value;
          } else {
            this[list].name = null;
          }
          this[list].page = 1;
          this.getAllAutocompleteItems(service, list, key, true, extraKey);
        }, 2000);
      }
    },
    getAllAutocompleteItems(service, list, key, sign, extraKey) {
      service({
        page: this[list].page,
        size: this[list].size,
        [key]: this[list].name,
        [extraKey]: this[list].extraKey
      })
        .then(response => {
          const data = response.data.data;
          const totalElements = data.totalElements;
          const items = data.content;
          sign === true ? (this[list].allItems = []) : this[list].allItems;
          this[list].allItems = this[list].allItems.concat(items);
          if (totalElements === this[list].allItems.length) {
            this[list].displayMoreItem = false;
          } else this[list].displayMoreItem = true;
        })
        .finally(() => {
          this[list].moreItemsLoading = false;
          this[list].autocompleteListLoading = false;
        });
    },
    getBusinessTypeInfo() {
      this.merchantType({
        name: this.tableData[0].businessType.businessTypeName
      }).then(response => {
        this.businessTypesList.allItems = response.data.data.content;
      });
    },
    getIsoInfo() {
      this.getCryptoCurrencyInfo(this.filtersObj.currencyId).then(response => {
        this.cryptoCurrencyList.allItems = response.data.data.content;
      });
    },
    getUserInfo() {
      Promise.all([
        this.getRelevantUserId(),
        this.getRelevantMerchantId()
      ]).then(() => {
        return true;
      });
    },
    getRelevantUserId() {
      this.allUsers({ userId: this.filtersObj.userId }).then(response => {
        return (this.usernamesList.allItems = response.data.data.content);
      });
    },
    getRelevantMerchantId() {
      if (this.filtersObj.businessId) {
        this.allMerchants({ businessId: this.filtersObj.businessId }).then(
          response => {
            return (this.businessNamesList.allItems =
              response.data.data.content);
          }
        );
      } else {
        return true;
      }
    },
    intersectUsernameList() {
      this.usernamesList.page++;
      this.usernamesList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.service,
        "usernamesList",
        "username",
        false
      );
    },
    intersectBusinessList() {
      this.businessNamesList.page++;
      this.businessNamesList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.service,
        "businessNamesList",
        "businessName",
        false,
        "userId"
      );
    },
    intersectBusinessTypesList() {
      this.businessTypesList.page++;
      this.businessTypesList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.merchantType,
        "businessTypesList",
        "name",
        false
      );
    }
  }
};
